












































/* ----------------------------------------
    Imports
---------------------------------------- */

import { Component, Prop, Vue } from 'vue-property-decorator';

/* ----------------------------------------
    Component
---------------------------------------- */

@Component({
    data() {
        return {
            email: '',
            password: '',
            errorData: null,
            submitted: false,
        };
    },

    methods: {
        submit() {
            if (this.submitted) return;

            this.$validator.validate().then(valid => {
                if (!valid) return;

                this.errorData = null;
                this.submitted = true;

                this.$store.dispatch('user/login', {
                    email: this.email,
                    password: this.password
                }).then(response => {
                    if (response instanceof Error)
                        this.errorData = response.response.data;

                    this.submitted = false;
                });
            });
        },
    },
})

/* ----------------------------------------
    Export
---------------------------------------- */

export default class LoginForm extends Vue {}

